import React, { useState } from "react";
import { RiPhoneFill } from "react-icons/ri";
import { RiPhoneLine } from "react-icons/ri";
import { Button, Modal, Spin } from "antd";
import { Link } from "react-router-dom";
function CallButton(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsModalVisible(true);
  };
  const handleOk = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsModalVisible(false);
  };
  const handleCancel = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsModalVisible(false);
  };
  return (
    <>
      <button onClick={(event) => showModal(event)} className="call-button">
        {" "}
        <span className="mr-1">
          <RiPhoneLine />
        </span>{" "}
        Call{" "}
      </button>
      <Modal
        width={350}
        footer={null}
        centered
        className="contact_n_model"
        title="Contact Us"
        open={isModalVisible}
        onOk={(event) => handleOk(event)}
        onCancel={(event) => handleCancel(event)}
      >
        <div className="contact_number__model">
          <h6>
            <span>
              <RiPhoneFill />
            </span>
            <a
              href="tel:+8801619913922"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                window.location.href = "tel:+8801619913922";
              }}
            >
              01619913922
            </a>

            {/* <Link to={"tel:+8801619913922"}>01619913922</Link> */}
          </h6>
          <h6>
            <span>
              <RiPhoneFill />
            </span>
            <a
              href="tel:+8801321216163"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                window.location.href = "tel:+8801321216163";
              }}
            >
              01321216163
            </a>
          </h6>
          <hr></hr>
          <p> Please quote property reference </p>
          <p>
            {" "}
            <b className="bold-text"> Property ID: {props?.property_id}</b>{" "}
          </p>
          <p>when calling us. </p>
        </div>
      </Modal>
    </>
  );
}

export default CallButton;
